module.exports = __webpack_public_path__ + "static/media/1POLICY22.21f1fbf4.jpg";